/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";
import { Table } from "react-bootstrap";
import * as XLSX from "xlsx";

export const Otros: FC = () => {
  let { staffId, isAdmin, userRoleId } = useSelector(
    ({ user }: IStore) => user as IUser
  );
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { OTROS } = paths;
  const [otros, setOtros] = useState<IOtroShort[]>([]);
  const [displayOtros, setDisplayOtros] = useState<IOtroShort[]>([]);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: string;
  } | null>(null);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);
  interface IOtroShort {
    [key: string]: any;
    id: string;
    tituloEs: string;
    tituloEn: string;
    resumenEs: string;
    resumenEn: string;
    tipo: string;
    fecha: string;    
    staffOtros?: {
      otroRole: string;
      staff: { nombre: string; apellidos: string };
    }[];
  }

  const loadData = async () => {
    try {
      const response = await getAll(OTROS, source);

      if (isMountedRef.current) {
        let filteredOtros = response;

        // Si el usuario NO es admin, aplicar el filtro
        if (!isAdmin) {
          filteredOtros = response.filter((otro: any) =>
            otro.staffOtros.some((staff: any) => staff?.staff?.id === staffId)
          );
        }

        setOtros(filteredOtros);
        setDisplayOtros(filteredOtros);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const searchBar = (value: string) => {
    const lowerCaseValue = value.toLowerCase(); // Solo convierte el valor a minúsculas

    setDisplayOtros(
      otros.filter(
        ({ tituloEs }) => tituloEs.toLowerCase().includes(lowerCaseValue) // Filtra solo por tituloEs
      )
    );

    if (!value) {
      setDisplayOtros(otros);
    }
  };

  const sortByColumn = (key: keyof IOtroShort) => {
    let direction = "desc";

    if (sortConfig?.key === key && sortConfig.direction === "desc") {
      direction = "asc";
    }

    setSortConfig({ key: key as string, direction });

    const sortedData = [...displayOtros].sort((a, b) => {
      if (key === "staffOtros") {
        // Extraer el apellido del primer IP en cada proyecto o asignar una cadena vacía si no existe
        const lastNameA =
          a.staffOtros?.find(({ otroRole }) => otroRole === "ip")?.staff
            ?.apellidos || "";
        const lastNameB =
          b.staffOtros?.find(({ otroRole }) => otroRole === "ip")?.staff
            ?.apellidos || "";

        // Proyectos sin IPs deben ir al final
        if (!lastNameA && lastNameB) return 1;
        if (!lastNameB && lastNameA) return -1;
        if (!lastNameA && !lastNameB) return 0;

        return (
          lastNameA.localeCompare(lastNameB) * (direction === "asc" ? 1 : -1)
        );
      }

      return a[key] < b[key]
        ? direction === "asc"
          ? -1
          : 1
        : a[key] > b[key]
        ? direction === "asc"
          ? 1
          : -1
        : 0;
    });

    setDisplayOtros(sortedData);
  };

  const columnHeaders: Record<string, string> = {
    tituloEs: "TÍTULO", // Cambio aquí, pero mantiene la clave "acronimo"
    tipo: "TIPO",
    fecha: "FECHA",
    staffOtros: "IPS",
  };

  const handleExportToExcel = () => {
    if (!otros) return;

    const dataToExport = otros.map((otro) => ({
      ID: otro.id,
      "Título (ES)": otro.tituloEs,
      "Título (EN)": otro.tituloEn,
      "Resumen (ES)": otro.resumenEs,
      "Resumen (EN)": otro.resumenEn,
      Estado: otro.estado,
      "Fecha": otro.fecha,
      Staff:
        otro.staffOtros
          ?.map(
            (s) =>
              `${s.otroRole}: ${
                s.staff
                  ? `${s.staff.nombre} ${s.staff.apellidos}`
                  : "Sin asignar"
              }`
          )
          .join(" | ") || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Otros");

    XLSX.writeFile(workbook, "otros.xlsx");
  };

  return (
    <div className="container-fluid p-4">
      {(isAdmin || userRoleId === 2 || userRoleId === 3) && (
        <>
          {" "}
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Otros</h3>
              </div>
              <div>
                <button
                  className="baseBtn"
                  onClick={() => history.push(ROUTES.Otros.create)}
                >
                  + Añadir
                </button>
                <button className="baseBtn ml-2" onClick={handleExportToExcel}>
                  Descargar Excel
                </button>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <Form.Group as={Col}>
              <InputGroup className="shadow">
                <InputGroup.Prepend>
                  <InputGroup.Text className="inputGroup ">
                    <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar por título o referencia..."
                  className="form-control"
                  onChange={({ target: { value } }) => searchBar(value)}
                />
              </InputGroup>
            </Form.Group>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                {Object.keys(columnHeaders).map((col) => (
                  <th
                    key={col}
                    onClick={() => sortByColumn(col)}
                    style={{ cursor: "pointer" }}
                  >
                    {columnHeaders[col]}{" "}
                    {sortConfig?.key === col
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {displayOtros?.length > 0 ? (
                displayOtros.map(
                  ({ id, tituloEs, tipo, fecha, staffOtros }) => {
                    // Filtramos los IPs
                    const ips =
                      staffOtros
                        ?.filter(({ otroRole }) => otroRole === "ip")
                        .map(
                          ({ staff }) => `${staff.nombre} ${staff.apellidos}`
                        )
                        .join(", ") || "-";

                    return (
                      <tr
                        key={id}
                        className="pointer"
                        onClick={() =>
                          history.push(`${ROUTES.Otros.all}/${id}`)
                        }
                      >
                        <td>{tituloEs}</td>
                        <td>{tipo || "-"}</td>
                        <td>
                          {fecha
                            ? new Date(fecha).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>{ips}</td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No se encontraron resultados
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
};
